export default __webpack_public_path__ + "static/media/23.589674d3.png";